/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { TransProps, useTranslation } from 'react-i18next';
import { array, BaseSchema, string as yupString, mixed, StringSchema, ArraySchema, object } from 'yup';

import { FormFieldType } from '../enums';
import { FormHelpers, ValidationRule } from '../interfaces';

export const useFormHelpers: () => FormHelpers = (): FormHelpers => {
  const { t }: TransProps<never> = useTranslation();

  const getSchemaRules = (fieldType: FormFieldType, rules?: ValidationRule[]): BaseSchema => {
    if (!rules?.length) {
      return mixed().notRequired();
    }

    const isMultipleChooseField: boolean = [FormFieldType.FullscreenDropdown, FormFieldType.AddPhoto].includes(fieldType);
    let defaultMessage: string = 'onarte.common.requiredField';
    let schemaRules: ArraySchema<StringSchema> | StringSchema = isMultipleChooseField
      ? array()
      : yupString();
    if (fieldType === FormFieldType.Autosuggest) {
      const requiredRule: ValidationRule | undefined = rules.find((rule: ValidationRule): boolean => rule.type === 'required');
      if (requiredRule) {
        return object().required(t(requiredRule?.message ?? defaultMessage));
      } else {
        return object().optional();
      }
    }

    rules.forEach((rule: ValidationRule): void => {
      switch (rule.type) {
        case 'required':
          defaultMessage = 'onarte.common.requiredField';
          schemaRules = schemaRules.required(t(rule?.message ?? defaultMessage));
          if (isMultipleChooseField) {
            schemaRules = schemaRules.min(1, t(rule?.message ?? defaultMessage));
          }
          break;
        case 'min':
          defaultMessage = isMultipleChooseField
            ? 'onarte.common.validations.minElementsInArray'
            : 'onarte.common.validations.minValue';
          schemaRules = schemaRules.min(rule.value as number, t(rule?.message ?? defaultMessage));
          break;
        case 'max':
          defaultMessage = isMultipleChooseField
            ? 'onarte.common.validations.maxElementsInArray'
            : 'onarte.common.validations.maxValue';
          schemaRules = schemaRules.max(rule.value as number, t(rule?.message ?? defaultMessage));
          break;
        case 'regexp':
          defaultMessage = 'onarte.common.wrongValue';
          schemaRules = (schemaRules as StringSchema).matches(rule.value as RegExp, t(rule?.message ?? defaultMessage));
          break;
      }
    });

    return schemaRules;
  };

  return { getSchemaRules };
};
